import { mapStory } from './storyMapper'
import { mapStoryAssets, mapAssets } from './assetMapper'
import { getPinStyles } from './pinsHelper'
import { sortStories } from './storyHelper'
import { ExhibitClient } from './exhibitClient'

export class StoryClient {
  constructor({ url, _get, _post, _put, _delete }) {
    this.url = url
    this.post = _post
    this.get = _get
    this.put = _put
    this.delete = _delete
  }

  help() {
    console.log('search({ appId, term, offset = 0 })')
    console.log('searchTags({ appId, tag })')
    console.log('searchBy({ appId, title, artist, keywords, collectionId, discipline, sortBy })')
    console.log('getById(id)')
    console.log('getAllByExhibitId(id)')
    console.log('getAll({ exhibitId, requireLocations, featured })')
    console.log('getFeaturedByExhibitId(id)')
    console.log('getAllPinLocationsByExhibitId(id, template, styleName)')
    console.log('getTagsById(id)')
    console.log('getPager({ exhibitId, order, limit, requireLocations, featured })')
    console.log('getAllByCollectionId(id. sortOrderLabel)')
    console.log('getAllByCollectionIdAndSubCollectionTitle(id, title, sortOrderLabel)')
  }

  getPager({ exhibitId, order, limit, requireLocations, featured }) {
    const fallback = { result: { rows: [] } }
    let page = 1
    let queryParams = ''
    let url = ''
    let res = ''

    const fun = async () => {
      queryParams = `order=${order}&page=${page}&limit=${limit}`
      queryParams += requireLocations ? '&requireLocations=true' : ''
      queryParams = this._addFeaturedQuery(queryParams, featured)

      url = `${this.url}/api/app/${exhibitId}/stories?${queryParams}`
      page += 1

      res = await this.get(url, fallback)
      if(res.success === false) {
        res = fallback
      }

      return res.result.rows.map(mapStory)
    }

    return { getPageOfStories: fun }
  }

  _addFeaturedQuery(query, featured) {
    if(featured === true) {
      query += '&featured=true'
    }

    if(featured === false) {
      query += '&featured=false'
    }

    return query
  }


  async getAll({ exhibitId, featured, requireLocations = false }) {
    if(!exhibitId) return []

    let queryParams = []
    if(requireLocations) {
      queryParams.push('requireLocations=true')
    }

    if(featured === true) {
      queryParams.push('featured=true')
    }

    if(featured === false) {
      queryParams.push('featured=false')
    }

    const qp = queryParams.join('&')
    let url = `${this.url}/api/app/get-stories/${exhibitId}?${qp}`
    const res = await this.get(url, { result: [] })

    return res.result
      .map(mapStory)

  }

  async getAllByExhibitId(id) {
    return this.getAll({ exhibitId: id })
  }

  async getAllByCollectionId(id, sortOrderLabel = 'Recently Added') {
    if(!id) return []

    const url = `${this.url}/api/collection/get/stories/${id}`
    const res = await this.get(url, { result: { stories: [] } })

    let stories = res.result.stories.map(mapStory)
    const sortOrder = ExhibitClient.getSortOrderName(sortOrderLabel)
    stories = sortStories(sortOrder, stories)

    return stories
  }

  async getAllByCollectionIdAndSubCollectionTitle(id, title, sortOrderLabel = 'Recently Added') {
    if(!id) return []

    const url = `${this.url}/api/collection/subcollection/stories/get/${id}/${title}`
    const res = await this.get(url, { result: [] })

    let stories = res.result.map(mapStory)
    const sortOrder = ExhibitClient.getSortOrderName(sortOrderLabel)
    stories = sortStories(sortOrder, stories)

    return stories
  }

  async getFeaturedByExhibitId(id) {
    if(!id) return []

    const url = `${this.url}/api/app/get-featured-stories/${id}`
    const res = await this.get(url, { result: [] })

    return res.result
      .map(mapStory)
  }

  async getAllPinLocationsByExhibitId(id, template, styleName) {
    if(!id) return []

    const url = `${this.url}/api/app/${id}/pin-locations`
    const res = await this.get(url, { result: { pins: [] } })
    const data = res.result

    const pinStyle = getPinStyles(template, styleName)

    const pins = data.pins.map(p => {
      p.pinImage = `${this.url}/${pinStyle.pinImage}`
      p.pinImageSelected = `${this.url}/${pinStyle.pinImageSelected}`
      p.image = `${this.url}/${pinStyle.pinImage}`
      return p
    })

    return pins
  }

  async getById(id) {
    if(!id) return null

    const url = `${this.url}/api/story/get/${id}`
    const res = await this.get(url, 'failed')
    let story = res.result.story
    if(story === 'failed' || story.name == 'CastError') return null

    story.assets = res.result.storyAssets

    story = mapStory(story)
    story.assets = mapStoryAssets(res.result.storyAssets)

    return story
  }

  async getByIdV3(id) {
    if(!id) return null

    const url = `${this.url}/api/story/get/${id}`
    const res = await this.get(url, null)
    let story = res.result.story

    if(story.name == 'CastError') return null

    story = mapStory(story)
    story.assets = mapAssets(story.assets)

    return story
  }

  async getTagsById(id) {
    if(!id) return null

    const url = `${this.url}/api/story/${id}/tags/get`
    const res = await this.get(url, { result: [] })
    const tags = res.result

    return tags
  }

  async search({ appId, term, offset = 0 }) {
    const url = `${this.url}/api/story/search`
    const queryParams = `?appId=${appId}&searchValue=${term}&offset=${offset}&orderBy=all`
    const res = await this.get(`${url}${queryParams}`, [])

    return res.result
      .map(mapStory)
  }

  async searchBy({ appId, title, artist, keywords=[], collectionId, discipline, sortBy }) {
    const url = `${this.url}/api/story/searchBy`
    keywords = keywords.filter(keyword => keyword?.length > 0).map(keyword => keyword.trim())

    const body =
    {
      appId,
      title,
      artist,
      keywords,
      collectionId,
      discipline,
      sortBy
    }


    const res = await this.post(url, body, { result: [] })

    return res.result.map(mapStory)
  }

  async searchTags({ appId, tag }) {
    if(!appId) return []

    const query = `/api/story/tags/search/${appId}/${tag}`
    const url = `${this.url}${query}`
    const res = await this.get(url, [])

    return res.map(mapStory)
  }

  async _save(story) {
    if (story.id) return await this._update(story)
    return await this._create(story)
  }

  async _create(story) {
    const url = `${this.url}/api/v3/story`
    const res = await this.post(url, { story })

    let newStory = res
    newStory = mapStory(newStory)

    return newStory
  }

  async _update(story) {
    story._id = story.id

    const url = `${this.url}/api/story/update/simple`
    const res = await this.post(url, { story })

    const { success } = res

    return success
  }

  async _delete(id) {
    const url = `${this.url}/api/story/${id}`
    return await this.delete(url)
  }
}
